module.exports = __webpack_public_path__ + "static/media/clock-large.bd38b34f.png";